(() => {
  const root = document.querySelector('[data-zyvoria-cookie]');
  if (!root || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  const summary = root.querySelector('[data-zyvoria-cookie-summary]');
  const preferences = root.querySelector('[data-zyvoria-cookie-preferences]');
  const status = root.querySelector('[data-zyvoria-cookie-status]');
  const consentInputs = [...root.querySelectorAll('[data-zyvoria-consent]')];
  const designMode = root.dataset.designMode === 'true';
  const dismissalKey = 'zyvoria_cookie_banner_until';
  const dismissalDuration = 5 * 24 * 60 * 60 * 1000;
  let privacyApi = null;

  const getCookieValue = (name) => {
    const prefix = `${name}=`;
    const match = document.cookie
      .split(';')
      .map((item) => item.trim())
      .find((item) => item.startsWith(prefix));
    return match ? match.slice(prefix.length) : '';
  };

  const getDismissedUntil = () => {
    let value = '';

    try {
      value = window.localStorage.getItem(dismissalKey) || '';
    } catch (_error) {
      value = '';
    }

    if (!value) value = getCookieValue(dismissalKey);

    const dismissedUntil = Number(value);
    return Number.isFinite(dismissedUntil) ? dismissedUntil : 0;
  };

  const dismissalIsActive = () => getDismissedUntil() > Date.now();

  const rememberDismissal = () => {
    const dismissedUntil = Date.now() + dismissalDuration;

    try {
      window.localStorage.setItem(dismissalKey, String(dismissedUntil));
    } catch (_error) {
      // The first-party cookie below remains available when local storage is blocked.
    }

    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${dismissalKey}=${dismissedUntil}; Max-Age=432000; Path=/; SameSite=Lax${secure}`;

    return dismissedUntil;
  };

  const setStatus = (message = '') => {
    if (status) status.textContent = message;
  };

  const syncInputs = () => {
    if (!privacyApi || typeof privacyApi.currentVisitorConsent !== 'function') return;
    const current = privacyApi.currentVisitorConsent();
    consentInputs.forEach((input) => {
      input.checked = current[input.dataset.zyvoriaConsent] === 'yes';
    });
  };

  const showSummary = () => {
    summary.hidden = false;
    preferences.hidden = true;
    root.hidden = false;
    setStatus();
  };

  const showPreferences = () => {
    if (!privacyApi) return;
    syncInputs();
    summary.hidden = true;
    preferences.hidden = false;
    root.hidden = false;
    setStatus();
    preferences.querySelector('input, button')?.focus();
  };

  const hide = () => {
    root.hidden = true;
    summary.hidden = false;
    preferences.hidden = true;
    setStatus();
  };

  const saveConsent = (payload) => {
    if (!privacyApi) return;
    setStatus('Saving your preferences...');
    privacyApi.setTrackingConsent(payload, (result) => {
      if (result && result.error) {
        setStatus('Your preferences could not be saved. Please try again.');
        return;
      }
      const dismissedUntil = rememberDismissal();
      hide();
      document.dispatchEvent(
        new CustomEvent('zyvoria:consent:updated', {
          detail: { ...payload, dismissedUntil },
        }),
      );
    });
  };

  root.querySelector('[data-zyvoria-cookie-accept]')?.addEventListener('click', () => {
    saveConsent({ analytics: true, marketing: true, preferences: true });
  });

  root.querySelector('[data-zyvoria-cookie-decline]')?.addEventListener('click', () => {
    saveConsent({ analytics: false, marketing: false, preferences: false });
  });

  root.querySelector('[data-zyvoria-cookie-manage]')?.addEventListener('click', showPreferences);
  root.querySelector('[data-zyvoria-cookie-close]')?.addEventListener('click', hide);

  root.querySelector('[data-zyvoria-cookie-save]')?.addEventListener('click', () => {
    const payload = {};
    consentInputs.forEach((input) => {
      payload[input.dataset.zyvoriaConsent] = input.checked;
    });
    saveConsent(payload);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-zyvoria-cookie-open]')) {
      event.preventDefault();
      showPreferences();
    }
  });

  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape' && !root.hidden) hide();
  });

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    (error) => {
      if (error || !window.Shopify.customerPrivacy) return;
      privacyApi = window.Shopify.customerPrivacy;
      document.documentElement.classList.add('zyvoria-custom-consent-ready');

      if (designMode || (privacyApi.shouldShowBanner() && !dismissalIsActive())) showSummary();
    },
  );
})();
